import apiClient from '@/lib/apiClient';
import { AdminSessionSummary, ApiResponse } from '@/types';

export const adminService = {
  // Admin-wide oversight: every active session across every user.
  getAllSessions: async (): Promise<AdminSessionSummary[]> => {
    const { data } = await apiClient.get<ApiResponse<AdminSessionSummary[]>>('/admin/sessions');
    return data.data ?? [];
  },

  revokeSession: async (id: number): Promise<void> => {
    await apiClient.delete(`/admin/sessions/${id}`);
  },
};
